module.exports = __webpack_public_path__ + "static/media/icon-five.1b42841a.webp";